import React, { useState } from "react";
import { ReactComponent as RightArrow } from "../../../../../assets/svgs/rightArrow.svg";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import { ReactComponent as BackIcon } from "../../../../../assets/svgs/back-square.svg";
import { ReactComponent as Drop } from "../../../../../assets/svgs/drop.svg";
import { QuestionForm } from "./QuestionForm";
import { sectionData } from "./sectionData";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";

const AddQuestion = ({ onCancel }) => {
  const [expandedSections, setExpandedSections] = useState({});
  const [expandedSubSections, setExpandedSubSections] = useState({});
  const [filteredData, setFilteredData] = useState(sectionData); // Store filtered data

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSearch = (searchTerm) => {
    const lowercasedTerm = searchTerm.toLowerCase();

    // Filter sectionData based on the search term
    const filteredSections = Object.keys(sectionData)
      .filter((key) => {
        // Filter sections whose title contains the search term
        const sectionMatches = key.toLowerCase().includes(lowercasedTerm);
        // Filter subsections within the section that match the search term
        const subsectionsMatch = sectionData[key].some((subSection) =>
          subSection.title.toLowerCase().includes(lowercasedTerm),
        );
        return sectionMatches || subsectionsMatch;
      })
      .reduce((acc, key) => {
        // Include the filtered section and its subsections
        acc[key] = sectionData[key].filter((subSection) =>
          subSection.title.toLowerCase().includes(lowercasedTerm),
        );
        return acc;
      }, {});

    // Set the filtered data to be displayed
    setFilteredData(filteredSections);
  };

  const toggleSubSection = (sectionKey, subSectionKey) => {
    setExpandedSubSections((prev) => ({
      ...prev,
      [`${sectionKey}-${subSectionKey}`]:
        !prev[`${sectionKey}-${subSectionKey}`],
    }));
  };

  return (
    <div>
      <div className="flex text-base font-light p-3">
        <p>Home</p>
        <span>
          <RightArrow />
        </span>
        <p>Form</p>
        <span>
          <RightArrow />
        </span>
        <TextStyles color="gradient">Add More</TextStyles>
      </div>

      <div
        style={{
          border: "1px solid #ebedf3",
          borderRadius: "10px",
          height: "100%",
        }}
      >
        <div className="flex gap-8 mx-8 my-2">
          <BackIcon onClick={onCancel} />
          <SearchBar onSearch={handleSearch} />
        </div>
        <div className="mx-12 mt-16 mb-28">
          {Object.keys(filteredData)
            .filter((key) => Array.isArray(filteredData[key])) // Only include keys that are arrays (valid sections)
            .map((sectionKey, sectionIndex) => (
              <div
                key={sectionIndex}
                className="bg-white rounded-xl px-5 py-4 mb-3 shadow-lg"
              >
                {/* Section Title */}
                <div
                  className="flex justify-between cursor-pointer"
                  onClick={() => toggleSection(sectionKey)}
                >
                  <h2 className="text-[#333333] font-semibold items-center my-auto text-lg">
                    {sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1)}
                  </h2>
                  <span
                    className={`transition-transform my-auto ${
                      expandedSections[sectionKey] ? "rotate-90" : ""
                    }`}
                  >
                    <Drop />
                  </span>
                </div>

                {/* Subsections */}
                {expandedSections[sectionKey] &&
                  filteredData[sectionKey].map(
                    (subSection, subSectionIndex) => (
                      <div
                        key={subSectionIndex}
                        className="shadow-lg bg-white px-5 py-2 mt-2 rounded-lg"
                      >
                        <div
                          className="flex justify-between cursor-pointer"
                          onClick={() =>
                            toggleSubSection(sectionKey, subSectionIndex)
                          }
                        >
                          <p className="font-semibold my-auto text-sm">
                            {subSection.title}
                          </p>
                          <RightArrow
                            className={`transition-transform ${
                              expandedSubSections[
                                `${sectionKey}-${subSectionIndex}`
                              ]
                                ? "rotate-90"
                                : ""
                            }`}
                          />
                        </div>

                        {/* Questions */}
                        {expandedSubSections[
                          `${sectionKey}-${subSectionIndex}`
                        ] && (
                          <div>
                            <h3 className="text-xs underline">
                              General Information
                            </h3>
                            <div className="mt-4 pl-4">
                              <QuestionForm questions={subSection.questions} />
                            </div>
                          </div>
                        )}
                      </div>
                    ),
                  )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default AddQuestion;
